import { dueDateToWeekKey, weekKeyToDueDate } from '@/utils/calendarWeek';

export const COMMITMENT_TEXT_MAX_LENGTH = 280;
export const COMMITMENT_REQUIRED_MIN_LENGTH = 10;

export function mapCommitmentDialogToApiPayload({
  was,
  woranErkennbar,
  wasKonkret,
  warumBedeutend,
  milestoneId,
  calendarWeekKey,
  ownerUserId,
}) {
  const dueDate = weekKeyToDueDate(calendarWeekKey);

  return {
    ownerUserId,
    was: String(was || '').trim(),
    woranErkennbar: String(woranErkennbar || '').trim(),
    wasKonkret: String(wasKonkret || '').trim(),
    warumBedeutend: String(warumBedeutend || '').trim(),
    milestoneId: milestoneId || null,
    dueDate: dueDate ? dueDate.toISOString() : '',
  };
}

export function mapCommitmentApiToDialog(commitment) {
  return {
    was: commitment?.was || '',
    woranErkennbar: commitment?.woranErkennbar || '',
    wasKonkret: commitment?.wasKonkret || '',
    warumBedeutend: commitment?.warumBedeutend || '',
    milestoneId: commitment?.milestoneId || null,
    calendarWeekKey: dueDateToWeekKey(commitment?.dueDate) || null,
    ownerUserId: commitment?.ownerUserId || '',
  };
}

function validateTextField(value, { required, fieldKey, translate }) {
  const trimmed = String(value || '').trim();
  if (required && trimmed.length < COMMITMENT_REQUIRED_MIN_LENGTH) {
    return translate(`UserProjects.commitmentDialog.validation.${fieldKey}Required`);
  }
  if (trimmed.length > COMMITMENT_TEXT_MAX_LENGTH) {
    return translate('UserProjects.commitmentDialog.validation.maxLength', {
      max: COMMITMENT_TEXT_MAX_LENGTH,
    });
  }
  return null;
}

export function validateCommitmentDialogForm(form, translate) {
  const errors = {};

  const wasError = validateTextField(form.was, {
    required: true,
    fieldKey: 'was',
    translate,
  });
  if (wasError) errors.was = wasError;

  const erkennbarError = validateTextField(form.woranErkennbar, {
    required: true,
    fieldKey: 'erkennbar',
    translate,
  });
  if (erkennbarError) errors.woranErkennbar = erkennbarError;

  const konkretError = validateTextField(form.wasKonkret, {
    required: false,
    fieldKey: 'konkret',
    translate,
  });
  if (konkretError) errors.wasKonkret = konkretError;

  const bedeutendError = validateTextField(form.warumBedeutend, {
    required: false,
    fieldKey: 'bedeutend',
    translate,
  });
  if (bedeutendError) errors.warumBedeutend = bedeutendError;

  if (!form.calendarWeekKey) {
    errors.calendarWeekKey = translate('UserProjects.commitmentDialog.validation.weekRequired');
  }

  if (form.hasOwnerOptions && !form.ownerUserId) {
    errors.ownerUserId = translate('ProjectManagement.commitments.validation.ownerUserIdRequired');
  }

  return errors;
}
